import api from '@/api';

import { API_BASE_URL } from '..';
import {
  EmployeeFunction,
  EmployeeFunctionCreate,
  EmployeeFunctionRequestParams,
  EmployeeFunctionUpdate,
} from './Functions.types';

const CONTROLLER_URL = `${API_BASE_URL}/functions`;

export async function listFunctions(params?: EmployeeFunctionRequestParams) {
  const result = (await api.get(`${CONTROLLER_URL}/filter`, params)) as unknown;

  return result as EmployeeFunction[];
}

export async function getFunction(id: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as EmployeeFunction;
}

export async function createFunction(data: EmployeeFunctionCreate) {
  const result = (await api.post(CONTROLLER_URL, data)) as unknown;

  return result as EmployeeFunction;
}

export async function updateFunction({ id, ...data }: EmployeeFunctionUpdate) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}`,
    { ...data },
    null,
  )) as unknown;

  return result as EmployeeFunction;
}

export async function removeFunction(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
